import { ROLE_ADMIN, ROLE_MASTER_DATA_ADMIN } from "AppConstants";

/**
 * Which user records a Master Data Admin is allowed to act on.
 *
 * A Master Data Admin reaches the user-management screen alongside an Admin (MasterRouterFactory),
 * so without this it can escalate itself by creating, editing, or deleting an Admin (HRMS-263).
 * Mirrors RoleAssignmentPolicy.PRIVILEGED_ROLES in user-auth, which is the enforcing side; the
 * checks here only avoid offering an action the server would refuse.
 *
 * @since NEXT_VERSION
 */
export const PRIVILEGED_ROLES = [ROLE_ADMIN, ROLE_MASTER_DATA_ADMIN];

/** @since NEXT_VERSION */
export const isPrivilegedRole = (role) => PRIVILEGED_ROLES.includes(role);

/**
 * True when the user holds Admin or Master Data Admin. Reads the grid row shape, where roles is an
 * array of { role } objects, and tolerates a missing or malformed list.
 *
 * @since NEXT_VERSION
 */
export const holdsPrivilegedRole = (user) => {
  const roles = user?.roles;
  if (!Array.isArray(roles)) return false;
  return roles.some((entry) => isPrivilegedRole(entry?.role));
};

/**
 * Whether the signed-in user may edit or delete the given user record. Only an Admin may act on a
 * record that itself holds a privileged role; everyone else gets a read-only view of it.
 *
 * @since NEXT_VERSION
 */
export const canModifyUser = (targetUser, callerIsAdmin) =>
  Boolean(callerIsAdmin) || !holdsPrivilegedRole(targetUser);

/** Shown on the disabled row actions so the restriction reads as deliberate. @since NEXT_VERSION */
export const PRIVILEGED_ROW_HINT =
  "Only an Admin can change a user holding the Admin or Master Data Admin role";
